import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import useQueryDhiHome from "../hooks/useQueryDhiHome";
import CardTopMinimalist from "../../shared/component/card/CardTopMinimalist";

const ArticleEventSection = () => {
  const { data } = useQueryDhiHome();
  const eventArticles = data?.pages.flatMap((page) => page.event);
  if (!eventArticles) return null;
  return (
    <div className="card w-full bg-neutral text-neutral-content shadow-xl p-6">
      <div className="flex justify-left items-center">
        <FontAwesomeIcon
          icon={["fas", "newspaper"]}
          className="text-blue-400 w-5 h-5"
        />
        <h2 className="text-2xl font-bold pl-2">Latest Event</h2>
      </div>

      <hr className="divider"></hr>
      <div className="flex flex-col gap-6">
        {eventArticles.map((newsItem, idx) => (
          <CardTopMinimalist
            key={newsItem.artikel_id || idx}
            image={
              newsItem.artikel_thumbnail
                ? `https://divhubinter.polri.go.id/${newsItem.artikel_thumbnail}`
                : undefined
            }
            title={newsItem.artikel_judul}
            type={newsItem.artikel_jenis}
            link={`newsdetail/${newsItem.artikel_id}`}
          />
        ))}
      </div>
    </div>
  );
};

export default ArticleEventSection;
